import React from 'react';
import { useRouter } from 'next/router';

import cx from 'classnames';
import { CanvasFooter } from 'themes/canvas/components/CanvasFooter/CanvasFooter';
import { CanvasNavigation } from 'themes/canvas/components/Navigation/CanvasNavigation';

import { useBnplBanner } from 'hooks/bnpl/useBnplBanner';
import { useGGTheme } from 'hooks/theme/useGGTheme';

import { BuyNowPayLaterBanner } from 'routes/home/components/BuyNowPayLaterBanner/BuyNowPayLaterBanner';

import { EnergyNavigation } from '../EnergyNavigation/EnergyNavigation';

import energyStyles from './EnergyLayout.module.css';
import canvasStyles from 'themes/canvas/components/CanvasLayout/CanvasLayout.module.css';

type TProps = {
  children: React.ReactNode;
};

const EnergyLayout = ({ children }: TProps) => {
  const router = useRouter();
  const isBookingFlow =
    router.pathname === '/book' ||
    router.pathname === '/waitlist' ||
    router.pathname === '/multi-book';
  const isHomePage = router.pathname === '/';

  const isBookNow = router.pathname === '/booking-flow';
  const step = router.query.step;
  const { themeMode, theme } = useGGTheme();

  const isSandPalette = theme && theme.palette.name === 'Sand';
  const isEnergyPalette = theme && theme.palette.name === 'Energy';

  const isDarkMode = themeMode === 'dark';

  let stepClass = '';

  if (typeof step === 'string') {
    stepClass =
      {
        'select-location': canvasStyles.selectLocation,
        'select-time': canvasStyles.selectTime,
        success: canvasStyles.success,
        // Add more mappings as needed
      }[step] || '';
  }

  const {
    elementRef,
    showBanner,
    bannerContainerStyle,
    onDismissBanner,
    isDismissed,
    bnplCapabilities,
    isLoading,
  } = useBnplBanner();

  return (
    <div
      className={cx(canvasStyles.canvas, {
        [canvasStyles.lightMode]: isBookingFlow && !isDarkMode,
        [canvasStyles.darkMode]: isBookingFlow && isDarkMode,
        [stepClass]: !!stepClass,
        [canvasStyles.bookingFlowPage]: isBookNow,
        [canvasStyles.bookingFlow]: isBookingFlow,
        [canvasStyles.sandPalette]: isSandPalette,
        [canvasStyles.energyPalette]: isEnergyPalette,
        [energyStyles.energy]: isEnergyPalette && !isBookingFlow,
      })}
      style={bannerContainerStyle}
    >
      {showBanner && (
        <BuyNowPayLaterBanner
          ref={elementRef}
          onDismissBanner={onDismissBanner}
          isDismissed={isDismissed}
          capabilities={bnplCapabilities}
          isLoading={isLoading}
        />
      )}
      {isHomePage ? <EnergyNavigation /> : <CanvasNavigation />}
      <div className={canvasStyles.layout}>
        {children}
        <CanvasFooter />
      </div>
    </div>
  );
};

export { EnergyLayout };
